/* cspell:ignore nics */
import { filterSpecBySkuModules, isSkuModuleEnabled } from '../../_shared/common/sku/skuEnabledModules';
import type { MiSpec } from './schema';

const MODULE_FIELD_STRIPS: Record<string, (spec: MiSpec) => MiSpec> = {
  baseInfo: (spec) => ({
    ...spec,
    alias: '',
    description: undefined,
    workspace: undefined,
  }),
  runtimeConfig: (spec) => ({
    ...spec,
    runtime: undefined,
  }),
  modelStorage: (spec) => ({
    ...spec,
    model: undefined,
  }),
  systemConfig: (spec) => ({
    ...spec,
    framework: undefined,
  }),
  healthCheck: (spec) => {
    const stripProbe = (group?: typeof spec.headGroupSpec) => {
      if (!group?.system) return group;
      const system = { ...(group.system as Record<string, unknown>) };
      delete system.livenessProbe;
      return { ...group, system };
    };
    return {
      ...spec,
      headGroupSpec: stripProbe(spec.headGroupSpec),
      workerGroupSpecs: spec.workerGroupSpecs?.map((group) => stripProbe(group)!),
      gateway: stripProbe(spec.gateway),
    };
  },
  service: (spec) => ({
    ...spec,
    network: spec.network
      ? {
          ...spec.network,
          service: undefined,
        }
      : undefined,
  }),
  envVars: (spec) => ({
    ...spec,
    environment: undefined,
  }),
  nic: (spec) => ({
    ...spec,
    network: spec.network
      ? {
          ...spec.network,
          nics: undefined,
          nicPricing: undefined,
        }
      : undefined,
  }),
  storage: (spec) => spec,
  nodeGroups: (spec) => ({
    ...spec,
    headGroupSpec: undefined,
    workerGroupSpecs: undefined,
    runMode: undefined,
    replicas: undefined,
    inference: undefined,
  }),
  gatewayConfig: (spec) => ({
    ...spec,
    gateway: undefined,
  }),
  kvOffload: (spec) => ({
    ...spec,
    kvOffload: undefined,
  }),
  initCommand: (spec) => ({
    ...spec,
    initCommand: undefined,
  }),
  taskConfig: (spec) => ({
    ...spec,
    taskTemplate: undefined,
  }),
};

export function filterMiSpecByEnabledModules(spec: MiSpec, enabledModules?: Record<string, boolean>, skuType?: 'fixed' | 'custom'): MiSpec {
  return filterSpecBySkuModules(spec, MODULE_FIELD_STRIPS, enabledModules, skuType);
}

export function isMiModuleEnabled(moduleKey: string, enabledModules?: Record<string, boolean>, skuType?: 'fixed' | 'custom'): boolean {
  return isSkuModuleEnabled(moduleKey, enabledModules, skuType);
}
